import { render, staticRenderFns } from "./tptGroup.vue?vue&type=template&id=5428c47a&scoped=true&"
import script from "./tptGroup.vue?vue&type=script&lang=js&"
export * from "./tptGroup.vue?vue&type=script&lang=js&"
import style0 from "./tptGroup.vue?vue&type=style&index=0&id=5428c47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428c47a",
  null
  
)

export default component.exports